import { getActiveBranchId } from '@/shared/api/apiClient';
import { bizDelete, bizGet, bizPatch, bizPost } from '@/shared/api/bizClient';

import type { BusinessService, UpsertBusinessServicePayload } from './types';

interface ListEnvelope<T> {
  items: T[];
}

function branchParams(): { branchId?: string } {
  const branchId = getActiveBranchId();
  return branchId ? { branchId } : {};
}

export async function listBusinessServices(): Promise<BusinessService[]> {
  const response = await bizGet<ListEnvelope<BusinessService>>('/biz/services', {
    params: branchParams(),
  });
  return response.items;
}

export async function createBusinessService(
  payload: UpsertBusinessServicePayload,
): Promise<BusinessService> {
  return bizPost<BusinessService, UpsertBusinessServicePayload>('/biz/services', payload);
}

export async function updateBusinessService(
  serviceId: string,
  payload: Partial<UpsertBusinessServicePayload>,
): Promise<BusinessService> {
  return bizPatch<BusinessService, Partial<UpsertBusinessServicePayload>>(
    `/biz/services/${serviceId}`,
    payload,
  );
}

export async function archiveBusinessService(
  serviceId: string,
  reason: string,
): Promise<void> {
  await bizDelete<void>(`/biz/services/${serviceId}`, { data: { reason } });
}
